"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dateFns = require("date-fns");
var _WebinarContent = _interopRequireDefault(require("./WebinarContent"));
var _HorizontalTab = _interopRequireDefault(require("../HorizontalTab/HorizontalTab"));
var _ItemListPanel = _interopRequireDefault(require("./ItemListPanel"));
var _dates = require("../_utils/dates");
var _excluded = ["items", "upcomingText", "ondemandText", "filtersLabel", "filterAndSortLabel", "wrapperClass", "emptyResultDefault", "toggleFilterAndSortModal", "selectedFacets", "facetState", "page", "pagination"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WebinarTabs = function WebinarTabs(props) {
  var items = props.items,
    upcomingText = props.upcomingText,
    ondemandText = props.ondemandText,
    filtersLabel = props.filtersLabel,
    filterAndSortLabel = props.filterAndSortLabel,
    wrapperClass = props.wrapperClass,
    emptyResultDefault = props.emptyResultDefault,
    toggleFilterAndSortModal = props.toggleFilterAndSortModal,
    selectedFacets = props.selectedFacets,
    facetState = props.facetState,
    page = props.page,
    pagination = props.pagination,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  // filter webinar sessions between daterange
  var filterSessionByDateRange = function filterSessionByDateRange(sessions) {
    var _ref = (facetState === null || facetState === void 0 ? void 0 : facetState.dateRange) || {},
      start = _ref.start,
      end = _ref.end;
    if (start || end) {
      var startDate = start ? new Date(start) : undefined;
      var endDate = end ? new Date(end) : undefined;
      return sessions.filter(function (item) {
        if (!item.timestamp || isNaN(Date.parse(item.timestamp))) return false;
        var itemDate = new Date(item.timestamp);
        if (startDate && endDate) return itemDate >= startDate && itemDate <= endDate;
        if (startDate) return itemDate >= startDate;
        if (endDate) return itemDate <= endDate;
        return true;
      });
    }
    return sessions;
  };

  // update the webinars list with filtered sessions
  var webinarItems = items.map(function (item) {
    var sessions = item.sessions && item.sessions.length > 1 ? filterSessionByDateRange(item.sessions) : item.sessions;
    return _objectSpread(_objectSpread({}, item), {}, {
      sessions: sessions
    });
  });

  // Order webinar sessions and return the newwest
  var getLastSession = function getLastSession(webinar) {
    var orderedWebinars = webinar.sessions.sort(function (a, b) {
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    });
    return orderedWebinars[webinar.sessions.length - 1];
  };
  var sortWebinars = function sortWebinars(a, b) {
    var _a$sessions$aPosition, _b$sessions$bPosition;
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'upcoming';
    var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'asc';
    var aPosition = 0;
    var bPosition = 0;

    // only when is future webinars order by the nearest session
    if (type === 'upcoming') {
      var _a$sessions, _b$sessions;
      var aDatesArray = (_a$sessions = a.sessions) === null || _a$sessions === void 0 ? void 0 : _a$sessions.map(function (s) {
        var _s$timestamp;
        return new Date((_s$timestamp = s.timestamp) === null || _s$timestamp === void 0 ? void 0 : _s$timestamp.substring(0, 23));
      });
      var bDatesArray = (_b$sessions = b.sessions) === null || _b$sessions === void 0 ? void 0 : _b$sessions.map(function (s) {
        var _s$timestamp2;
        return new Date((_s$timestamp2 = s.timestamp) === null || _s$timestamp2 === void 0 ? void 0 : _s$timestamp2.substring(0, 23));
      });

      // get nearest session position in array of sessions
      var today = new Date();
      aPosition = (0, _dateFns.closestIndexTo)(today, aDatesArray);
      bPosition = (0, _dateFns.closestIndexTo)(today, bDatesArray);
    }
    var aTime = new Date((_a$sessions$aPosition = a.sessions[aPosition]) === null || _a$sessions$aPosition === void 0 ? void 0 : _a$sessions$aPosition.timestamp).getTime();
    var bTime = new Date((_b$sessions$bPosition = b.sessions[bPosition]) === null || _b$sessions$bPosition === void 0 ? void 0 : _b$sessions$bPosition.timestamp).getTime();
    if (aTime < bTime) return order === 'asc' ? -1 : 1;
    if (aTime > bTime) return order === 'asc' ? 1 : -1;
    return 0;
  };
  var isOnDemand = function isOnDemand(webinar) {
    // if no date set, add it to on demand list
    if (webinar.sessions.length < 1) return true;
    var lastSession = webinar.sessions.length === 1 ? webinar.sessions[0] : getLastSession(webinar);
    return (0, _dates.isDateOlderThanToday)(lastSession.timestamp);
  };
  var itemsUpcoming = items.filter(function (item) {
    return !isOnDemand(item);
  }).sort(sortWebinars);
  var itemsOnDemand = webinarItems.filter(function (item) {
    return isOnDemand(item);
  }).sort(function (a, b) {
    return sortWebinars(a, b, 'ondemand', 'desc');
  });
  var tabLabels = [{
    title: "".concat(upcomingText, ": (").concat(itemsUpcoming.length, ")"),
    name: upcomingText,
    itemParameter: 'upcoming'
  }, {
    title: "".concat(ondemandText, ": (").concat(itemsOnDemand.length, ")"),
    name: ondemandText,
    itemParameter: 'ondemand'
  }];

  // default query param
  var queryParam = 'selected-panel';
  var activeItem = 0;
  // switch to ondemand if upcoming is empty
  if (itemsUpcoming.length === 0 && itemsOnDemand.length > 0) {
    activeItem = 1;
  }
  var _useState = (0, _react.useState)(''),
    selectedTab = _useState[0],
    setSelectedTab = _useState[1];
  return __jsx(_react.default.Fragment, null, __jsx(_HorizontalTab.default, {
    items: tabLabels,
    activeIndex: activeItem,
    queryParam: queryParam,
    setSelectedTab: setSelectedTab,
    isWebinars: true
  }, __jsx(_ItemListPanel.default, {
    filtersLabel: filtersLabel,
    filterAndSortLabel: filterAndSortLabel,
    wrapperClass: wrapperClass,
    emptyResultDefault: emptyResultDefault,
    selectedFacets: selectedFacets,
    toggleFilterAndSortModal: toggleFilterAndSortModal,
    translations: {
      page: page,
      pagination: pagination
    },
    selectedTab: selectedTab,
    renderContent: function renderContent(itemsUpcoming) {
      return __jsx(_WebinarContent.default, (0, _extends2.default)({}, itemsUpcoming, otherProps, {
        type: "upcoming"
      }));
    },
    id: 'upcoming-tab',
    items: itemsUpcoming
  }), __jsx(_ItemListPanel.default, {
    filtersLabel: filtersLabel,
    filterAndSortLabel: filterAndSortLabel,
    wrapperClass: wrapperClass,
    emptyResultDefault: emptyResultDefault,
    selectedFacets: selectedFacets,
    toggleFilterAndSortModal: toggleFilterAndSortModal,
    selectedTab: selectedTab,
    renderContent: function renderContent(itemsOnDemand) {
      return __jsx(_WebinarContent.default, (0, _extends2.default)({}, itemsOnDemand, otherProps, {
        type: "ondemand"
      }));
    },
    id: 'ondemand-tab',
    items: itemsOnDemand,
    translations: {
      page: page,
      pagination: pagination
    }
  })));
};
var _default = WebinarTabs;
exports.default = _default;